module.exports = __webpack_public_path__ + "static/media/RecomendaFlorianopolis.af67c5e2.jpg";